<template>
	<div class="item_media item_vod">
		<div class="wrap_vod_info">
			<div class="info_vod" :style="layerStyle">
				<iframe :src="videoPlayUrl" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		inheritAttrs: false,
		props: ['layer'],
		computed: {
			layerStyle() {
				return `width:${this.layer.width}px`;
			},
			videoPlayUrl() {
				if (this.layer.autoplay) {
					if (this.layer.host === 'youtube') {
						return this.layer.videoPlayUrl + '?autoplay=1';
					}
					return this.layer.videoPlayUrl + '&autoplay=1';
				}
				return this.layer.videoPlayUrl;
			}
		}
	}
</script>
